import React, { useState } from 'react';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import AdvancedForm from '@portal/components/AdvancedForm/AdvancedForm';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import AdvancedInput from '@portal/components/AdvancedInput/AdvancedInput';
import { validatePassword } from '@portal/utils/validate';
import PasswordCheck from '@portal/components/PasswordCheck/PasswordCheck';

import { passwordRules } from '@portal/config/app.json';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface PasswordValidation {
  min: boolean;
  max: boolean;
  number?: boolean;
  uppercase?: boolean;
  lowercase?: boolean;
  special?: boolean;
}

interface IProps {
  password: string;
  setPassword: (password: string) => void;
  handleSubmit: () => void;
  passwordValidation: PasswordValidation;
  setPasswordValidation: (value: PasswordValidation) => void;
  checkPasswordValidation: (value: PasswordValidation) => boolean;
  loading: boolean;
  title: string;
}

const CreateNewPassword = ({
  password,
  setPassword,
  handleSubmit,
  passwordValidation,
  checkPasswordValidation,
  loading,
  title,
}: IProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="create-new-password">
      <ThemedText variant="body" className="create-new-password__title">
        {title}
      </ThemedText>
      <AdvancedForm onSubmit={handleSubmit}>
        <AdvancedInput
          testId="change-password_AdvancedInput_password"
          value={password}
          onChange={setPassword}
          placeholder={'*'.repeat(passwordRules.minLength ?? 8)}
          securedTextField={!showPassword}
          endIcon={
            !showPassword ? (
              <EyeOutlined onClick={() => setShowPassword(true)} />
            ) : (
              <EyeInvisibleOutlined onClick={() => setShowPassword(false)} />
            )
          }
          maxLength={passwordRules.maxLength}
        />
        <div className="m-3">
          <PasswordCheck
            password={password}
            passwordValidation={passwordValidation}
          />
        </div>
        <AdvancedButton
          testId="change-password_AdvancedButton_click"
          text="Trocar senha"
          fullWidth
          type="submit"
          disabled={
            !checkPasswordValidation(validatePassword(password)) || loading
          }
        />
      </AdvancedForm>
    </div>
  );
};

export default CreateNewPassword;
